<button (click)="navigate()" style = "border-radius:25px;padding:5px;padding-right:25px;padding-left:25px;font-weight: bold;background-color:#6E1FD2;border-color:#6E1FD2;display:flex;margin:0 auto;" class = "btn-primary">View My Subscriptions</button>
<button (click)="feedback()" style = "border-radius:25px;padding:5px;padding-right:25px;padding-left:25px;font-weight: bold;background-color:#6E1FD2;border-color:#6E1FD2;display:flex;margin:0 auto;margin-top:10px;" class = "btn-primary">Report a bug</button>
<div style = "margin-top:20px;display:flex;justify-content: center;">
	
	<h2>OR</h2>
</div>
<app-alter-sub></app-alter-sub>
